import { NgModule } from '@angular/core';

import { DialogOutletDirective } from './dialog-outlet.directive';

@NgModule({
  declarations: [DialogOutletDirective],
  exports: [DialogOutletDirective],
})
export class DialogOutletModule {}

export { DialogOutletDirective };
